var _a;
import { createActions } from 'redux-actions';
export var resetHidden = (_a = createActions('RESET_HIDDEN', 'SAVE_HIDDEN'), _a.resetHidden), saveHidden = _a.saveHidden;
